// @ts-nocheck
import resolveColor from "@insite/mobius/utilities/resolveColor";

/**
 * Use in styled-components template strings to pull color values from the theme as a CSS filter property.
 * @param {string} path The path to extract from `theme.color`.
 * @return {function} A function that accepts component props and attempts to access the color defined in the function argument.
 */
export default function getColorFilter(path = "") {
    return (props: any) => {
        const cssFilter = props.theme.colors.cssFilter[resolveColor(path, props.theme)];

        if (!cssFilter) {
            return null;
        }

        return `filter: ${cssFilter};`;
    };
}
